import Card from "components/card/Card";
import Page from "components/page/Page";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { ButtonNew as Button } from "components/buttonNew";
import "../loyalty.scss";
import DataTable from "components/dataTable/DataTable";
import { ILoyaltyProgram, IOffer } from "redux/reducers/models/loyalty";
import axios, { CancelToken } from "axios";
import {
    GetLoyaltyProgram,
    // DeleteLoyaltyProgramOffer, 
    GetLoyaltyProgramOffers,
    // PostDuplicateLoyaltyProgramOffer, 
    PostLoyaltyProgramStep2,
} from "api/rpc/2024-04/facilityAdmin/customer/loyalty";
import { StatusCode } from "api/protocols";
import { showError, showSuccess } from "redux/actions/ui";
import Toggle from "components/form/toggle/Toggle";
import { displayCurrency } from "helpers/Helpers";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import LoyaltyProgramOffersModal from "./LoyaltyProgramOffersModal";
import useModal from "hooks/modals/useModal";
// import Popup from "components/popup/Popup";
import { isEqualWith, isNull } from "lodash";
import ReactDOM from "react-dom";

interface IState {
    offers: Array<IOffer>;
    loyaltyProgram: ILoyaltyProgram;
}


export default function LoyaltyProgramPointsStep2() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const [state, setState] = useState<IState>({
        offers: null,
        loyaltyProgram: null,
    });
    const [offersBeforeState, setOffersBeforeState] = useState(state?.offers);
    const { state: offerModal, updateModal: updateOfferModal, closeModal: closeOfferModal } = useModal<{ offer: IOffer }>({ offer: null });
    // const { state: deleteModal, updateModal: updateDeleteModal, closeModal: closeDeleteModal } = useModal<{offer: IOffer}>({offer: null});
    // const { state: duplicateModal, updateModal: updateDuplicateModal, closeModal: closeDuplicateModal } = useModal<{offer: IOffer}>({offer: null});

    const { facilityStore } = useAppSelector(store => store);

    useEffect(() => {
        const source = axios.CancelToken.source();
        void getOffers(source.token);
        return () => source.cancel();
    }, []);

    async function getOffers(cancelToken?: CancelToken) {
        const res = await GetLoyaltyProgramOffers(true, cancelToken);
        if (res?.status !== StatusCode.OK) {
            if (cancelToken && cancelToken?.reason) {
                return;
            }
            dispatch(showError(t("Error getting offers")));
            return;
        }
        const programRes = await GetLoyaltyProgram(true);
        if (programRes?.status !== StatusCode.OK) {
            if (cancelToken && cancelToken?.reason) {
                return;
            }
            dispatch(showError(t("Error getting loyalty program")));
            return;
        }
        ReactDOM.unstable_batchedUpdates(() => {
            setState(prev => ({ ...prev, offers: res?.data, loyaltyProgram: programRes?.data }));
            setOffersBeforeState(res?.data as SetStateAction<IOffer[]>);
        });
    }


    function getTypeText(type: string, amount_spent: number) {
        switch (type) {
            case "amount_spent":
                return `${displayCurrency(facilityStore?.facility?.default_currency_code, amount_spent)} ${t("spent")}`;
            case "product_purchased":
                return t("Product purchased");
            case "welcome_bonus":
                return t("Sign up");
            case "birthday_bonus":
                return t("Birthday bonus");
            default:
                return t("");
        }
    }

    async function handleAddOffer(offer: Partial<IOffer>) {
        if (!offer?.title) {
            dispatch(showError(t("Title required")));
            return;
        }

        if (offer?.points_expiry_type === "expire_after_days" && isNaN(offer?.points_expiry_days)) {
            dispatch(showError(t("Expiry days required")));
            return;
        }

        const res = await PostLoyaltyProgramStep2({ offers: [offer] }, true);
        if (res?.status !== StatusCode.OK) {
            dispatch(showError(t("Error updating offers")));
            return;
        }
        dispatch(showSuccess(t("Successfully added offer")));
        //refresh offers
        await getOffers();
        void closeOfferModal();
    }

    // async function handleDeleteOffer() {
    //     if (deleteModal?.offer) {
    //         const res = await DeleteLoyaltyProgramOffer({id: deleteModal?.offer?.id}, true);
    //         if (res?.status !== StatusCode.OK) {
    //             dispatch(showError(t("Error deleting offer")));
    //             return;
    //         }
    //         dispatch(showSuccess(t("Successfully deleted offer")));
    //         //refresh offers
    //         await getOffers();
    //         void closeDeleteModal();
    //     }
    // }

    // async function handleDuplicateOffer() {
    //     if (duplicateModal?.offer) {
    //         const res = await PostDuplicateLoyaltyProgramOffer({id: duplicateModal?.offer?.id}, true);
    //         if (res?.status !== StatusCode.OK) {
    //             dispatch(showError(t("Error duplicating offer")));
    //             return;
    //         }
    //         dispatch(showSuccess(t("Successfully duplicated offer")));
    //         //refresh offers
    //         await getOffers();
    //         void closeDuplicateModal();
    //     }
    // }

    function handleToggleStatus(index: number) {
        if (state?.offers) {
            const updatedOffers = [...state.offers]?.map((offer, offerIndex) => offerIndex === index ? { ...offer, active: !offer.active} : offer);
            setState(prev => ({ ...prev, offers: updatedOffers }));
        }
    }

    function navigateToNextStep() {
        if (state?.offers?.length === 0) {
            dispatch(showError(t("At least one offer required before continuing to the next step")));
            return;
        }
        if (state?.loyaltyProgram?.type === "cash_back") {
            history.push("/admin/settings/loyalty-program");
            return;
        }
        history.push("/admin/settings/loyalty-program/points/step-3");
    }

    async function handleSaveOffers() {
        const res = await PostLoyaltyProgramStep2({ offers: state?.offers }, true);
        if (res?.status !== StatusCode.OK) {
            dispatch(showError(t("Error updating offers")));
            return;
        }
        dispatch(showSuccess(t("Successfully updated offers")));
        //refresh offers
        await getOffers();
    }

    function unsavedChangesExist() {
        if (offersBeforeState === null) {
            if (state?.offers) {
                setOffersBeforeState(state?.offers);
            }
            return false;
        }

        return !isEqualWith(offersBeforeState, state?.offers, (originalValue, newValue) => {
            if ((isNull(originalValue) || originalValue === "") && (isNull(newValue) || newValue === "")) {
                return true;
            }
        });
    }

    return (
        <Page
            narrow
            title={t("Step 2: Add Points to your Program")}
            breadcrumbs={[
                {
                    prefix: true,
                    label: t("Back"),
                    url: "/admin/settings/loyalty-program",
                },
            ]}
            notificationBarProps={{
                isVisible: unsavedChangesExist(),
                onAction: () => handleSaveOffers(),
                onCancel: () => setState(prev => ({ ...prev, offers: offersBeforeState })),
            }}
        >
            <Card title={t("Points")} subtitle={t("Set how customers earn points for purchases")}
            //titleActions={[{content: "+ Add Ways to Earn", buttonType: "secondary", action: () => updateOfferModal({isOpen: true})}]}
            >
                <Card.Section>
                    <br />
                    <div className="loyalty-data-table">
                        <DataTable
                            columns={[{ label: t("How to earn") }, { label: "", width: "40%" }, { label: t("Status") }, { label: "" }]}
                            className="min-h-auto"
                        >
                            {state?.offers?.map((offer, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <p style={{ color: "#101828" }}>{offer?.title}</p>
                                            <p>{getTypeText(offer?.type, offer?.amount_spent)} = {offer?.points_earned} Points</p>
                                        </td>
                                        <td></td>
                                        <td>
                                            <Toggle checked={offer?.active} onChange={() => handleToggleStatus(index)} />
                                        </td>

                                        <td>
                                            <NavigationDropdownNew
                                                showPlainTextLabel
                                                rightAlign
                                                label={<FontAwesomeIcon icon={faEllipsisVertical} />}
                                                sections={[
                                                    [
                                                        {
                                                            label: t("Edit"),
                                                            icon: "pen-to-square",
                                                            onClick: () => updateOfferModal({ isOpen: true, offer: offer }),
                                                        },
                                                        //   {
                                                        //     label: t("Duplicate"),
                                                        //     icon: "copy",
                                                        //     onClick: () => updateDuplicateModal({isOpen: true, offer: offer}),
                                                        //   },
                                                        //   {
                                                        //     label: t("Delete"),
                                                        //     icon: "trash-can",
                                                        //     onClick: () => updateDeleteModal({isOpen: true, offer: offer}),
                                                        //   },
                                                    ],
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </DataTable>
                    </div>
                </Card.Section>
            </Card>
            <div className="loyalty-button-container">
                <Button type="primary" size="medium" onClick={() => navigateToNextStep()}>{t("Next")}</Button>
            </div>

            <LoyaltyProgramOffersModal
                open={offerModal?.isOpen}
                onCancel={() => closeOfferModal()} 
                onOk={offer => handleAddOffer(offer)} 
                offer={offerModal?.offer}
            />
            {/* <Popup title={t("Delete Offer")} type="warning" description={`${t("Are you sure you want to delete offer")}: ${deleteModal?.offer?.title}?`} open={deleteModal?.isOpen} onCancel={closeDeleteModal} onOk={handleDeleteOffer} okText={t("Delete")} />
        <Popup title={t("Duplicate Offer")} type="info" description={`${t("Are you sure you want to duplicate offer")}: ${duplicateModal?.offer?.title}?`} open={duplicateModal?.isOpen} onCancel={closeDuplicateModal} onOk={handleDuplicateOffer} okText={t("Duplicate")} /> */}

        </Page>
    );
}
